import PropTypes from "prop-types"
import React, { useState } from "react"

import FormTelephoneField from "./FormTelephoneField"

const ContactPhoneField = ({
  value: initialValue,
  name,
  disabled,
  required = false,
}) => {
  const [value, setValue] = useState(initialValue || "")

  return (
    <>
      <input type="hidden" name={name} value={value} />
      <FormTelephoneField
        value={value}
        onChange={setValue}
        disabled={disabled}
        id={name}
        required={required}
      />
    </>
  )
}

ContactPhoneField.propTypes = {
  value: PropTypes.string,
  name: PropTypes.string.isRequired,
  disabled: PropTypes.bool,
  required: PropTypes.bool,
}

export default ContactPhoneField
